module.exports = __webpack_public_path__ + "static/media/noProductImg_420x420.7ea2870e.jpg";